import { AnyAction } from 'redux'
import { RootState } from './state'
import { User } from '../../api/model/User'

export const userConstants = {
  LOGIN_REQUEST: 'USER_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USER_LOGIN_FAILURE',
  LOGOUT: 'USER_LOGOUT',
  USER_MODIFIED: 'USER_MODIFIED',
}

const lsUser = localStorage.getItem('user')
const user = lsUser && (JSON.parse(lsUser) as User)

const initialState: RootState.AuthState = user
  ? {
      loggingIn: false,
      loggedIn: true,
      user: { ...user },
    }
  : {
      loggingIn: false,
      loggedIn: true,
    }
export function authReducer(state = initialState, action: AnyAction): RootState.AuthState {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        loggedIn: false,
        usernameBeingLoggedIn: action.username,
      }
    case userConstants.LOGIN_SUCCESS:
      return {
        loggingIn: false,
        loggedIn: true,
        user: { ...action.user },
      }
    case userConstants.LOGIN_FAILURE:
      return {
        loggingIn: false,
        loggedIn: false,
      }
    case userConstants.LOGOUT:
      return {
        loggingIn: false,
        loggedIn: false,
      }
    case userConstants.USER_MODIFIED:
      return {
        ...state,
        user: { ...action.user },
      }
    default:
      return state
  }
}
